import {
  GetRepayCodePageReq,
  GetRepayCodePageCond,
  GetRepayCodePageCondReq
} from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { ticketClient } from "@/api/ticketClient";

interface ITicketLogReq {
  pageIndex: number;
  pageSize: number;
  OrderId: string;
  CustomerId: string;
  Mobile: string;
  CustomerName: string;
  EAccountNumber: string;
  RepayCodeList: any[];
  AppName: string;
}
export function getRepayCode(arg: ITicketLogReq) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request = new GetRepayCodePageReq();
      request.setCommonin(setCommon());
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      let innerRequest = new GetRepayCodePageCond();
      innerRequest.setOrderid(arg.OrderId);
      innerRequest.setCustomerid(arg.CustomerId);
      innerRequest.setMobile(arg.Mobile);
      innerRequest.setCustomername(arg.CustomerName);
      innerRequest.setEaccountnumber(arg.EAccountNumber);
      innerRequest.setAppname(arg.AppName);
      let innerItemRequestList: any[] = [];
      arg.RepayCodeList.forEach((item: any) => {
        let innerItemRequest = new GetRepayCodePageCond.RepayCodeItem();
        if (item.code) {
          innerItemRequest.setPaymentname(item.codeName);
          innerItemRequest.setPaymentcode(item.code);
          innerItemRequest.setPaymentchannel(item.channel);
          innerItemRequestList.push(innerItemRequest);
        }
      });
      innerRequest.setRepaycodeList(innerItemRequestList);
      request.setCond(innerRequest);
      console.log(request);
      await ticketClient.getRepayCodePage(
        request,
        {},
        (err: any, response: any) => {
          console.log(response);
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      console.log(response);
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}

// export function getRepayCodePageCondreq() {
//   return new Promise((resolve, reject) => {
//     (async () => {
//       let request = new GetRepayCodePageCondReq();
//       request.setCommonin(setCommon());
//       console.log(request);
//       await ticketClient.getRepayCodePageCond(
//         request,
//         {},
//         (err: any, response: any) => {
//           console.log(response);
//           if (response) {
//             const res: any = response.toObject();
//             resolve(res);
//           }
//           if (err) {
//             reject(err);
//           }
//         }
//       );
//     })();
//   })
//     .then((response: any) => {
//       console.log(response);
//       handleResponse(response, null);
//       return response;
//     })
//     .catch((err: any) => {
//       errorMsg(err);
//     });
// }
